// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"9e101e9b","412":"0a18cd63","583":"a2e7b93b","623":"e1e98fd0"}[chunkId] + ".chunk.js";
};